import * as React from 'react';
import * as _ from 'underscore';

import { CommonStyles } from '../../common/react/CommonStyles';

export class HeaderMenuItem extends React.Component<HeaderMenuItem.Props, HeaderMenuItem.State> {

  static displayName = 'HeaderMenuItem';

  static element = React.createFactory(HeaderMenuItem);

  private static linkStyle = {
    display: 'block',
    padding: CommonStyles.Sizes.DefaultSpace,
    textDecoration: 'none',
    color: CommonStyles.Colors.Grey102,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  private boundMouseEnter: () => void;
  private boundMouseLeave: () => void;

  state: HeaderMenuItem.State = {
    hovered: false
  };

  constructor(props: HeaderMenuItem.Props) {
    super(props);
    this.boundMouseEnter = () => this.setState({ hovered: true });
    this.boundMouseLeave = () => this.setState({ hovered: false });
  }

  public render() {

    const style = _.extend({}, HeaderMenuItem.linkStyle, {
      color: this.props.isDisabled ? CommonStyles.Colors.Grey225 : CommonStyles.Colors.Grey102,
      backgroundColor: this.state.hovered && !this.props.isDisabled ? CommonStyles.Colors.Grey245 : 'inherit',
      cursor: this.props.isDisabled ? 'default' : 'pointer'
    });

    return React.createElement('a', {
        href: this.props.url,
        title: this.props.title,
        target: this.props.target,
        'data-tb-test-id': this.props.tbTestId,
        style: style,
        onClick: this.props.onClick,
        onMouseEnter: this.boundMouseEnter,
        onMouseLeave: this.boundMouseLeave
      } as React.HTMLAttributes<HTMLAnchorElement>,
      this.props.label);
  }

}

export module HeaderMenuItem {

  export interface Props {
    label: string;
    url?: string;
    isDisabled?: boolean;
    title?: string;
    onClick?: () => void;
    target?: string;
    tbTestId: string;
  }

  export interface State {
    hovered: boolean;
  }
}
